import { CSSProperties } from 'react';

export const picker: CSSProperties = {
  margin: 10,
};
